/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  PlanNotificationTriggerType,
  useSendTestPlanNotificationMutation,
} from "~/generated/graphql";
import { showError, showInfo } from "~/services/toast";

type Props = {
  planId: string;
};

type SendTestParams = {
  planNotificationGroupId: string;
  triggerEvent: PlanNotificationTriggerType;
};

export function useSendTestPlanNotification({ planId }: Props) {
  const [sendTestPlanNotificationMutation, { loading }] =
    useSendTestPlanNotificationMutation({
      onCompleted: (data) => {
        if (data?.sendTestPlanNotification) {
          showInfo("Test notification sent.");
        }
      },
      onError: (error: Error) => showError(error.message),
    });

  async function sendTest({
    planNotificationGroupId,
    triggerEvent,
  }: SendTestParams) {
    if (!planId) {
      return;
    }

    await sendTestPlanNotificationMutation({
      variables: {
        input: {
          planId,
          planNotificationGroupId,
          triggerEvent,
        },
      },
    });
  }

  return [sendTest, { loading }] as const;
}
